import { RQ } from 'utils';
import { addClickAnalytics, addRouteAnalytics } from 'utils/analytics';

export default {
  async init () {
    // console.log('=============路由变化了===========');
    const { materialId, materialTitle } = this.$route.query;
    this.pageTitle = materialTitle;
    await this.getArticleInfo({materialId});
    this.hotCommentList = await this.getHotCommentList({materialId});
    this.commentData = await this.getCommentList({page: 1, pageSize: 3, materialId});
    this.recommendList = await this.getOtherArticle(1);
  },
  /**
   * 获取文章(视频)详情
   **/
  async getArticleInfo (params) {
    const res = await RQ.mall.get('/api/h5/material/getMaterialDetail', { ...params }, {enterprise: '', loading: false});
    console.log('-----------getArticleInfo', params, res);
    if (res && (res.code === -3 || !res.data)) {
      this.articleData = {
        ...res,
        data: {}
      }
    } else {
      this.articleData = res;
      const {commentNum, isLiked, likeNum} = res.data;
      this.commentNum = commentNum;
      this.isLiked = isLiked;
      this.likeNum = likeNum;
    }
    return res;
  },
  /**
   * 获取热评列表（无分页）
   * @params materialId
   * @returns {Promise.<*>}
   */
  async getHotCommentList (params) {
    const res = await RQ.mall.get('/api/h5/material/getHotCommentList', { ...params }, {enterprise: '', loading: false});
    return res;
  },
  /**
   * 获取评论
   **/
  async getCommentList (params) {
    const res = await RQ.mall.get('/api/h5/material/getCommentList', {
      pageSize: 20,
      ...params
    }, {
      enterprise: '',
      loading: false
    });
    console.log('-----------getCommentList', params, res);
    return res;
  },
  /**
   * 获取其他文章
   **/
  async getOtherArticle () {
    const {materialId, businessType} = this.$route.query;
    // console.log('====================businessType',businessType);
    let res = await RQ.mall.get('/api/h5/material/getMaterialList', {
      materialType: this.materialType,
      page: this.page,
      pageSize: this.pageSize,
      enterpriseNo: G.member.enterprise,
      businessType,   // 增加商家类型，用于推荐同类文章
      excludeMaterialId: materialId
    }, {
      // jsonBody: true,
      enterprise: '',
      loading: false
    });
    if (res && res.code == 0) {
      console.log('===============getOtherArticle',res.data);
      for (let i = 0; i < res.data.pageData.length; i++) {
        this.recommentList.push(res.data.pageData[i])
      }
      this.recommTotal = res.data.total;
    }
  },
  /**
   * 跳转评论页
   **/
  handleToCommentList(item = {}) {
    const { materialId } = this.$route.query;
    this.$router.push({
      path: `/wp/app/commentList/${materialId}`,
      query: {
        materialId,
        ...item
      }
    });
  },
  /**
   * 点赞操作
   * 调用接口时，likeType字段、likeUser字段与isLiked字段是必须传递的，
   * 这样后端才知道点赞类型和是否点赞。如果是文章点赞，只需要materialId。
   * 如果是评论点赞，需要materialId和materialCommentId。
   * params: likeType,likeUser,materialId,materialCommentId,isLiked
   **/
  async handleLikeArticle (params) {
    let res = await RQ.mall.post('/api/h5/material/likeArticle', {
      ...params
    }, {jsonBody: false, enterprise: '', loading: false});
    if (res && res.code == 0) {
      console.log(res);
    }
  },
  /**
   * banner切换
   **/
  handleBannerChange (index) {
    this.bannerIndex = index;
  },
  /**
   * 跳转分享页
   **/
  handleShare () {
    const { materialId, materialType, materialTitle, homeImg, materialContent } = this.$route.query;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `浏览文章_${materialId}_wxapp` });
        wx.miniProgram.getEnv((res) => {
          console.log('------res', res);
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/module/other/pages/sharePoster/index?original=wxapp&materialId=${materialId}&materialType=${materialType}&materialTitle=${materialTitle}&shareImg=${homeImg}&materialContent=${materialContent}`,
              success: function (res) {
                console.log('success', res)
              },
              fail: function (res) {
                console.log('fail', res);
              },
              complete: function (res) {
                console.log('complete', res);
              }
            });
          }
        });
      } else if (window.ReactNativeBridge) {
        // app
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'ArticleShare',
          params: {
            materialId, materialType, original: 'app'
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        addClickAnalytics({ LogTitle: `浏览文章_${materialId}_app` });
      } else {
        addClickAnalytics({ LogTitle: `浏览文章_${materialId}_h5` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
        // const queryStr = `?goodsId=${goodsId}&specialId=${specialId}&groupGiftId=${groupGiftId}`;
        // this.submitFn(queryStr);
      }
      console.log('-----------this.env', this.env);
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  /**
   * 跳转商品详情
   **/
  handleToGoods (item) {
    const {goodsId, specialId, groupGiftId} = item;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_wxapp` });
        wx.miniProgram.navigateTo({url: `/pages/goods/index?goodsId=${goodsId}&groupGiftId=${groupGiftId}&original=wxapp`});
      } else if (window.ReactNativeBridge) {
        // app
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'Goods',
          params: {
            goodsId, specialId, groupGiftId, original: 'app'
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        });
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_app` });
      } else {
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_h5` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
        // const queryStr = `?goodsId=${goodsId}&specialId=${specialId}&groupGiftId=${groupGiftId}`;
        // this.submitFn(queryStr);
      }
      console.log('-----------this.env', this.env);
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  /**
   * 跳转其他文章
   **/
  handleToArticle (item = {}) {
    this.$router.push({
      path: `/wp/app/article/${item.materialId}`,
      query: {
        materialId: item.materialId,
        materialTitle: item.materialTitle
      }
    });
  },
  handleonLoad () {
    // 异步更新数据
    setTimeout(() => {
      this.page++;
      this.getOtherArticle();
      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.pageSize * this.page >= this.recommTotal) {
        this.finished = true;
      }
    }, 500);
  },
  /**
   * 素材操作（点赞）
   **/
  handleToOperation() {
    const { materialId } = this.$route.query;
    const isLiked = this.isLiked;
    isLiked ? this.likeNum-- : this.likeNum++;
    this.isLiked = isLiked ? 0 : 1;
    this.handleLikeArticle({
      materialId: materialId,
      materialCommentId: null,
      likeType: 1,
      isLiked: isLiked ? 0 : 1
    });
  },
  handleToLike(e, commentId) {
    console.log('---------handleToLike', e, commentId);
    let iconEle = e.srcElement;
    // let iconEle = e.srcElement.parentElement.firstElementChild
    const { materialId } = this.$route.query;
    let likeType = commentId ? 2 : 1;
    if (iconEle.classList.contains("icon-icon-heart-d-")) {
      // iconEle.classList.remove("icon-icon-heart-d-", "icon-red");
      // iconEle.classList.add("icon-icon-heart-");
      // iconEle.nextElementSibling.innerText--;
      iconEle.previousElementSibling.style.display = 'block';
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.innerText--;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 0
      });
    } else {
      // iconEle.classList.remove("icon-icon-heart-");
      // iconEle.classList.add("icon-icon-heart-d-", "icon-red");
      // iconEle.nextElementSibling.innerText++;
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.style.display = 'block';
      iconEle.nextElementSibling.nextElementSibling.innerText++;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 1
      });
    }
  },
  handleToReply() {
    console.log('---------handleToReply')
  },
  handleToLookMore() {
    console.log('---------handleToLookMore')
  },
  handleSendComment () {
    console.log('===========发表评论');
  },

};



// WEBPACK FOOTER //
// ./src/module/app/article/action.js